import { FetchAvailableSalesActors } from 'epic/postTradeOperations/addon/fetchAddonSalesActorsEpic';
import { SalesBeneficiary } from 'models/forms/SalesBeneficiary';
import { Item } from 'models/IItem';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export type SalesDesksApi = FetchAvailableSalesActors;

export function OrganizationApi(http$: IHttpClient): SalesDesksApi {
  return {
    fetchAvailableSalesDesks(rtfeLogin: string) {
      return http$
        .getJSON<Item<number>[]>({
          url: `api/v1/organization/sales-desks`,
          params: { rtfeLogin },
        })
        .pipe(map(({ payload }) => payload));
    },
    fetchAvailableSalesBeneficiaries(salesDesk: number) {
      return http$
        .getJSON<Item<SalesBeneficiary>[]>({
          url: `api/v1/organization/sales-beneficiaries`,
          params: { salesDesk },
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
